export type QcVariant = 'pass' | 'fail' | 'warning' | 'na' | null;

export function getQcVariant(value: string | null | undefined): QcVariant {
  switch (value) {
    case 'Pass':
      return 'pass';
    case 'Fail':
      return 'fail';
    case 'Partial':
    case 'Warning':
      return 'warning';
    case 'N/A':
      return 'na';
    default:
      return null;
  }
}

export function needsTooltip(variant: QcVariant): boolean {
  return variant === 'fail' || variant === 'warning';
}
